<template>
    <v-dialog
        persistent
        width="500"
        v-model="display"
        >
        <v-card>
            <v-card-title>{{ title }}</v-card-title>
            <v-card-subtitle>{{ $t('TRUCK_TYPE_SUBTITLE') }}</v-card-subtitle>
            <v-card-text>
                <div class="text-center" v-if="loading.data">
                    <v-progress-circular
                        indeterminate
                        color="primary">
                    </v-progress-circular>
                </div>
                <v-form
                    v-model="valid"
                    ref="form"
                    v-if="!loading.data">
                    <v-text-field
                        :label="$t('TRUCK_TYPES_NAME')"
                        :rules="nameRequired"
                        v-model="form.name"
                        >
                    </v-text-field>
                </v-form>
            </v-card-text>
            <v-card-actions>
                <v-btn
                    text
                    :disabled="!valid || loading.submit || loading.data"
                    :loading="loading.submit"
                    @click="submit">
                    {{ $t('BTN_SAVE') }}
                </v-btn>
                <v-btn
                    text
                    @click="close"
                    >
                    {{ $t('BTN_CANCEL') }}
                </v-btn>
            </v-card-actions>
        </v-card>
        <AlertDialog 
            ref="alertDialog"
            />
    </v-dialog>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import AlertDialog from '../components/AlertDialog'

export default {
    name: "TruckTypeDialog",
    components: {
        AlertDialog
    },
    data() {
        return {
            id: null,
            form: {
                name: null
            },
            display: false,
            valid: false,
            editMode: false,
            nameRequired: [
                v => !!v || this.$t('RULES_REQUIRED_MSG')
            ],
            loading: {
                data: false,
                submit: false
            }
        }
    },
    computed: {
        ...mapState("truckType", ["truckType"]),
        title() {
            if(!this.editMode) return this.$t('TRUCK_TYPE_NEW_TITLE');
            else return this.$t('TRUCK_TYPE_EDIT_TITLE');
        }
    },
    methods: {
        ...mapActions("truckType", ["storeTruckType", "fetchTruckType", "fetchTruckTypes", "updateTruckType"]),
        async open(params) {
            this.loading.data = true;
            this.editMode = params.editMode;
            this.display = true;
            if(this.editMode) {
                await this.fetchTruckType(params.id);
                this.form = this.truckType;
                this.id = params.id;
            }
            this.loading.data = false;
        },
        close() {
            this.loading.submit = false;
            this.display = false;
            this.$refs.form.reset();
            this.$refs.form.resetValidation();
        },
        submit() {
            this.loading.submit = true;
            if(this.editMode == false) {
                this.storeTruckType(this.form)
                    .then((response) => {
                        this.$emit("done", response.message);
                        this.fetchTruckTypes();
                        this.close();
                        this.$emit("record", response.record);
                    })
                    .catch((error) => {
                        this.$emit("done", error.message);
                        this.close();
                    })
            } else if(this.editMode == true) {
                this.updateTruckType({form: this.form, id: this.id})
                    .then(response => {
                        this.$emit("done", response.message);
                        this.fetchTruckTypes();
                        this.close();
                    })
                    .catch(error => {
                        this.$emit("done", error.message);
                        this.close();
                    })
            }
        }
    }
}
</script>